import React from "react";
import { Box } from "@mui/material";
import AgentIcon from "./AgentIcon";

export const AGENT_BG_ZOOM = 1.4;
export const AGENT_BG_INSET = 8;

export function agentArtSize(size: number, zoom = AGENT_BG_ZOOM) {
    return Math.round(size * zoom);
}

export default function FadedAgentArt({
    agent,
    size = 56,
    zoom = AGENT_BG_ZOOM,
    asBackground = false,
    fade = "right",
    zIndex,
    sx,
}: {
    agent?: string | null;
    size?: number;
    zoom?: number;
    faded?: boolean;
    asBackground?: boolean;
    fade?: "right" | "left" | "none" | "soft";
    zIndex?: number | "auto";
    sx?: object;
}) {
    if (!agent) return null;
    const img = agentArtSize(size, zoom);
    const inset = asBackground ? AGENT_BG_INSET : 0;
    const slot = img + inset;
    const dissolve =
        fade === "left"
            ? "linear-gradient(288deg, #000 0%, #000 38%, rgba(0,0,0,0.78) 54%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.12) 86%, transparent 100%)"
            : fade === "soft"
              ? "linear-gradient(108deg, #000 0%, #000 58%, rgba(0,0,0,0.82) 74%, rgba(0,0,0,0.4) 88%, transparent 100%)"
              : "linear-gradient(108deg, #000 0%, #000 38%, rgba(0,0,0,0.78) 54%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.12) 86%, transparent 100%)";
    const maskSx =
        fade === "none"
            ? {}
            : {
                  maskImage: dissolve,
                  WebkitMaskImage: dissolve,
                  maskRepeat: "no-repeat",
                  WebkitMaskRepeat: "no-repeat",
                  maskSize: "100% 100%",
                  WebkitMaskSize: "100% 100%",
              };
    const portrait = (
        <AgentIcon
            agent_name={agent}
            sx={{
                position: "absolute",
                width: img,
                height: img,
                minWidth: img,
                minHeight: img,
                left: inset,
                top: "50%",
                transform: "translateY(-50%)",
                filter: "brightness(1.18) contrast(1.06)",
            }}
        />
    );

    const layer = zIndex === "auto" ? undefined : zIndex ?? (asBackground ? 1 : undefined);

    if (asBackground) {
        return (
            <Box
                sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: slot,
                    zIndex: layer,
                    pointerEvents: "none",
                    overflow: "hidden",
                    ...maskSx,
                    ...sx,
                }}
            >
                {portrait}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: slot,
                minWidth: slot,
                height: size,
                flexShrink: 0,
                position: "relative",
                overflow: "hidden",
                pointerEvents: "none",
                ...maskSx,
            }}
        >
            {portrait}
        </Box>
    );
}
